import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { FormlySelectModule } from '@ngx-formly/core/select';
import { FormlyIonicModule } from '@ngx-formly/ionic';
import { FormlyFieldProps } from '@ngx-formly/ionic/form-field';

@Component({
  selector: 'ts-slider-field',
  styleUrls: ['./slider-field.component.scss'],
  templateUrl: './slider-field.component.html',
  imports: [
    IonicModule,
    FormlyIonicModule,
    FormlySelectModule,
    ReactiveFormsModule,
  ],
})
export class SliderFieldComponent extends FieldType<
  FieldTypeConfig<FormlyFieldProps>
> {}
